import {urls, api} from '@/api'
import * as types from '@/store/mutation-types'

const getInitialState = () => ({

  // Common
  purchases: [],

  // Filters
  aggregations: {},

  // Paginator
  page: 1,
  per_page: 25,
  totalPages: null,
  totalPurchases: null,

})

const state = getInitialState()

const actions = {

  fetchPurchases: ({commit, state}, params = {}) => {

    // set paginator parameters
    if (params.page) {
      commit(types.PURCHASES_LIST_SET_PAGE, params.page)
    } else {
      params.page = state.page
    }
    params.per_page = state.purchases_per_page

    return api.get(urls.userPurchases, { params })
      .then(({data}) => {

        // TODO: make searches and filters
        const aggregations = Array.isArray(data.aggregations) ? {} : data.aggregations

        commit(types.PURCHASES_LIST_SET_PURCHASES, data.data)
        commit(types.PURCHASES_LIST_SET_PAGE, data.meta.pagination.page)
        commit(types.PURCHASES_LIST_SET_TOTAL_PAGES, data.meta.pagination.total_pages)
        commit(types.PURCHASES_LIST_SET_TOTAL_PURCHASES, data.meta.pagination.total)
        commit(types.PURCHASES_LIST_SET_AGGREGATIONS, aggregations)

      })
      .catch(er => {})
  },

  setPage: ({commit}, page) => { commit(types.PURCHASES_LIST_SET_PAGE, page) },
}

const mutations = {


  [types.PURCHASES_LIST_SET_PURCHASES] (state, purchases) {
    state.purchases = purchases
  },

  [types.PURCHASES_LIST_SET_PAGE] (state, page) {
    state.page = parseInt(page)
  },

  [types.PURCHASES_LIST_SET_TOTAL_PAGES] (state, total) {
    state.totalPages = total
  },

  [types.PURCHASES_LIST_SET_TOTAL_PURCHASES] (state, total) {
    state.totalPurchases = total
  },

  [types.PURCHASES_LIST_SET_AGGREGATIONS] (state, total) {
    state.aggregations = total
  }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/purchases-list.js